import { CommonModule } from "@angular/common";
import {
  HttpClientModule,
  withInterceptorsFromDi,
  withXhr,
} from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PipesModule } from "../pipes/pipes.module";
import { AffectedTrainListComponent } from "./affected-train-list/affected-train-list.component";
import { CheckboxComponent } from "./checkbox/checkbox.component";
import { ClickOutsideDirective } from "./click-outside.directive";
import { InputFieldComponent } from "./input-field/input-field.component";
import { TextAreaComponent } from "./text-area/text-area.component";
import { SpinnerComponent } from "./spinner/spinner.component";
import { PopupComponent } from "./popup/popup.component";
import { PopoverComponent } from "./popover/popover.component";
import { DropdownComponent } from "./dropdown/dropdown.component";
import { DatetimeFieldComponent } from "./datetime-field/datetime-field.component";
import { provideHttpClient } from "@angular/common/http";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDateFormats,
  MatNativeDateModule,
} from "@angular/material/core";
import { SwedishDateAdapter } from "./datetime-field/datetime-field.component";

const DUA_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: null,
    timeInput: null,
  },
  display: {
    dateInput: { year: "numeric", month: "numeric", day: "numeric" },
    timeInput: { hour: "numeric", minute: "numeric" },
    monthYearLabel: { year: "numeric", month: "long" },
    dateA11yLabel: { year: "numeric", month: "long", day: "numeric" },
    monthYearA11yLabel: { year: "numeric", month: "long" },
    timeOptionLabel: { hour: "numeric", minute: "numeric" },
  },
};

@NgModule({
  declarations: [
    AffectedTrainListComponent,
    CheckboxComponent,
    InputFieldComponent,
    TextAreaComponent,
    ClickOutsideDirective,
    SpinnerComponent,
    PopupComponent,
    PopoverComponent,
    DropdownComponent,
    DatetimeFieldComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  exports: [
    AffectedTrainListComponent,
    CheckboxComponent,
    InputFieldComponent,
    TextAreaComponent,
    ClickOutsideDirective,
    SpinnerComponent,
    PopupComponent,
    PopoverComponent,
    DropdownComponent,
    DatetimeFieldComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    BrowserAnimationsModule,
    HttpClientModule,
  ],
  providers: [
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: MAT_DATE_LOCALE, useValue: "sv-SE" },
    { provide: DateAdapter, useClass: SwedishDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: DUA_DATE_FORMATS },
  ],
})
export class SharedModule {}
